"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Cloud core Open Api for vod-ott-action-details service
 * These are the endpoints for cloudcore-vod-ott-action-details service in cloud core deployments.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: vod-dev@xperi.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
/**
 * Type of action
 * @export
 * @enum {string}
 */
exports.ActionType = {
    WatchFromSoCuAction: 'watchFromSoCuAction',
    WatchFromVodAction: 'watchFromVodAction',
    WatchFromOttAction: 'watchFromOttAction'
};
